import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const features = [
    {
      icon: 'Shield',
      title: 'Dual-Factor Authentication',
      description: 'QR code + PIN provides enhanced security for staff access'
    },
    {
      icon: 'Lock',
      title: 'Account Protection',
      description: 'Automatic lockout after 5 failed PIN attempts for 15 minutes'
    },
    {
      icon: 'Clock',
      title: 'Automatic Time Tracking',
      description: 'Clock in automatically upon successful authentication'
    },
    {
      icon: 'FileText',
      title: 'Audit Logging',
      description: 'All authentication attempts are logged for security monitoring'
    },
    {
      icon: 'Smartphone',
      title: 'Mobile Optimized',
      description: 'Full camera integration for QR scanning on mobile devices'
    },
    {
      icon: 'Zap',
      title: 'Quick Access',
      description: 'Fast authentication workflow designed for busy staff'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="card">
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-foreground mb-2 flex items-center gap-2">
            <Icon name="ShieldCheck" size={20} className="text-primary" />
            Security Features
          </h3>
          <p className="text-sm text-muted-foreground">
            Professional security standards for workforce authentication
          </p>
        </div>

        <div className="space-y-4">
          {features?.map((feature, index) => (
            <div key={index} className="flex items-start gap-3 p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={20} className="text-primary" />
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground mb-1">
                  {feature?.title}
                </h4>
                <p className="text-xs text-muted-foreground">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="card bg-gradient-to-br from-primary/5 to-primary/10 border-primary/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div className="text-sm">
            <p className="font-medium text-foreground mb-2">Need Help?</p>
            <ul className="space-y-1 text-muted-foreground">
              <li>• Contact your manager to set up your PIN</li>
              <li>• QR codes are available in your profile</li>
              <li>• Report lost QR codes immediately</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityFeatures;